module.exports = __webpack_public_path__ + "static/media/SVA200228992.c5ed3338.pdf";